<template>
    <div>
        <b-modal
            v-model="modalConfirm"
            :width="640"
            scroll="keep"
        >
            <div class="card">
                <div class="card-content">
                    <div class="media">
                        <div class="media-content">
                            <p
                                style="padding:0px"
                                class="title is-4"
                            >Edit order</p>
                        </div>
                    </div>

                    <div
                        class="columns is-multiline"
                        v-if="order"
                    >
                        <b-field
                            class="column is-4"
                            label="ORDER ID"
                            label-position="inside"
                        >
                            <b-input
                                disabled
                                size="is-small"
                                v-model="order.id"
                            ></b-input>
                        </b-field>
                        <b-field
                            class="column is-8"
                            label="ORIGIN"
                            label-position="inside"
                        >
                            <b-select
                                size="is-small"
                                placeholder="Select branch"
                                v-model="order.origin"
                            >
                                <option
                                    v-for="option in branchs"
                                    :value="option.name"
                                    :key="option.code"
                                >
                                    {{ option.name }}
                                </option>
                            </b-select>
                        </b-field>
                        <b-field
                            class="column is-6"
                            label="CUSTOMER NAME"
                            label-position="inside"
                        >
                            <b-input
                                size="is-small"
                                v-model="order.name"
                            ></b-input>
                        </b-field>
                        <b-field
                            class="column is-6"
                            label="CUSTOMER PHONE NO."
                            label-position="inside"
                        >
                            <b-input
                                size="is-small"
                                v-model="order.phone"
                            ></b-input>
                        </b-field>
                        <b-field
                            style="margin-bottom: 0px;"
                            class="column is-12"
                            label="DESTINATION"
                            label-position="inside"
                        >
                            <b-input
                                size="is-small"
                                v-model="order.destination"
                                type="textarea"
                                minlength="10"
                                maxlength="100"
                            >
                            </b-input>
                        </b-field>
                        <div class="column is-6 pt-0">
                            <b-button
                                type="is-danger is-light"
                                @click="onEditMapModal"
                            >EDIT DESTINATION</b-button>
                        </div>
                        <div
                            style="text-align:right"
                            class="column is-6"
                        >
                            <a @click="onFindAddress(order.destination)">Find this destination on google map</a>
                        </div>
                    </div>
                </div>
            </div>
            <footer
                class="modal-card-foot"
                style="justify-content: flex-end;"
            >
                <b-button
                    label="Close"
                    @click="modalConfirm = false"
                />
                <b-button
                    label="Save"
                    @click="onUpdateOrder"
                    type="is-primary"
                />
            </footer>
            <b-loading
                :is-full-page="false"
                v-model="isLoading"
                :can-cancel="true"
            ></b-loading>
        </b-modal>
    </div>
</template>

<script>
import branchs from "@/settings/branchs";
import EditMap from "../components/ModalMap.vue";
export default {
  props: ["orderId"],
  data() {
    return {
      modalConfirm: false,
      isLoading: false,
      branchs: branchs,
      order: null,
    };
  },
  watch: {
    modalConfirm() {
      if (this.modalConfirm) {
        this.getSingleOrder();
      } else {
        this.order = null;
      }
    },
  },
  methods: {
    onEditMapModal() {
      this.$buefy.modal.open({
        parent: this,
        // fullScreen: true,
        props: {
          initLocation: this.order.destination,
          initLocationLatLng: this.order.destinationLocation,
        },
        component: EditMap,
        hasModalCard: true,
        trapFocus: true,
        events: {
          onConfirm: async (val) => {
            this.order.destination = val.text;
            this.order.destinationLocation = val.latlng;
          },
        },
      });
    },
    async getSingleOrder() {
      this.isLoading = true;
      const result = await this.$store.dispatch("orders/getSingleOrder", this.orderId);
      this.order = result;
      this.isLoading = false;
    },
    onFindAddress(address) {
      const url = `https://www.google.com.sa/maps/search/${address}`;
      window.open(url, "_blank");
    },
    async onUpdateOrder() {
      this.isLoading = true;
      const result = await this.$store.dispatch("orders/updateOrderInfo", {
        id: this.order.id,
        origin: this.order.origin,
        name: this.order.name,
        phone: this.order.phone,
        destination: this.order.destination,
        destinationLocation: this.order.destinationLocation,
      });
      // test-2021-06-24#2
      if (result.data && result.data.updateOrder) {
        this.$buefy.notification.open({
          message: `ORDER ID ${this.order.id} ได้ทำการแก้ไขเรียบร้อยแล้ว`,
          type: "is-success",
          duration: 5000,
          queue: false,
        });
      } else {
        const errorMessage = result.errors ? result.errors[0].message : `แก้ไข ORDER ID ${this.order.id} ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง`;
        this.$buefy.notification.open({
          message: errorMessage,
          type: "is-danger",
          duration: 5000,
          queue: false,
        });
      }
      this.isLoading = false;
      this.modalConfirm = false;
    },
  },
};
</script>

<style scoped></style>
